import React from "react";
import WizardShell from "./wizard/WizardShell";
import { useAuth } from "../contexts/AuthContext";

/**
 * Backwards-compatible entry point — existing pages import this component.
 * The actual implementation now lives in /components/wizard/* and is a full
 * 10-step premium wizard with autosave, gallery editor, crop, services
 * matrix, pricing grid, schedule, contact preferences, verification status
 * and a live preview.
 */
export default function ProfileWizard({ role, profile, onClose, onSaved }) {
  const { user } = useAuth();
  return (
    <WizardShell
      role={role}
      profile={profile}
      onClose={onClose}
      onSaved={onSaved}
      currentUserId={user?.id}
    />
  );
}
